module.exports = __webpack_public_path__ + "static/media/pat.89f97641.svg";